"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSessions = exports.getCurrentActivityHandle = exports.getCurrentActivity = exports.getActiveSessionId = exports.getActiveSession = void 0;
var _reselect = require("reselect");
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isNil2 = _interopRequireDefault(require("lodash/isNil"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getSessions = exports.getSessions = function getSessions(state) {
  return state.sessions;
};
var getActiveSessionId = exports.getActiveSessionId = function getActiveSessionId(state) {
  return state.activeSessionId;
};
var getCurrentActivityHandle = exports.getCurrentActivityHandle = function getCurrentActivityHandle(state) {
  return state.currentActivityHandle;
};
var getActiveSession = exports.getActiveSession = (0, _reselect.createSelector)(getSessions, getActiveSessionId, function (sessions, activeSessionId) {
  if (activeSessionId === 0) {
    return {};
  }
  return (0, _find2["default"])(sessions, function (s) {
    return s.responseSet === activeSessionId;
  });
});
var getCurrentActivity = exports.getCurrentActivity = (0, _reselect.createSelector)(getActiveSession, getCurrentActivityHandle, function (session, currentActivityHandle) {
  if (!(0, _isNil2["default"])(session) && !(0, _isEmpty2["default"])(session)) {
    return (0, _find2["default"])(session.activities, function (a) {
      return a.handle === currentActivityHandle;
    });
  }
  return {};
});